import { Component, Input, Output, EventEmitter, OnChanges, OnInit } from '@angular/core';
import * as fromUser from '@app/core/user/store/reducers';
import { Product } from '@vestiaire/api-sdk-angular';
import { select, Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import { HelpersService } from '@app/shared/services/helpers/helpers.service';
import { ProductClick, TrackingModule } from '@app/+product/store';

@Component({
  selector: 'vc-products-arrangement',
  templateUrl: './products-arrangement.component.html',
  styleUrls: ['./products-arrangement.component.scss']
})
export class ProductsArrangementComponent implements OnChanges, OnInit {
  @Input() items: Product[];
  @Input() seoContext: string[] = [];
  @Input() itemMax: number;
  @Input() isSlider: boolean;
  @Input() trackingTitle: string;

  @Output() productClick = new EventEmitter<ProductClick>();
  @Output() moduleScroll = new EventEmitter<TrackingModule>();
  @Output() moduleDisplay = new EventEmitter<TrackingModule>();

  products: Product[] = [];
  likedItem: string[] = [];
  isMdUp = false;
  eventClick: Event;
  prevClickable = false;
  nextClickable = true;
  itemMin = 4;
  isFirstScroll = false;

  constructor(private store: Store<IAppState>, private helperService: HelpersService) {
    this.store.pipe(select(fromUser.getLikedItems)).subscribe(
      productsLiked => productsLiked && (this.likedItem = productsLiked['products']),
      error => console.error(error)
    );
    this.isMdUp = this.helperService.device.isMdUp();
  }

  ngOnInit() {
    const event: TrackingModule = { title: this.trackingTitle };
    this.moduleDisplay.emit(event);
  }

  ngOnChanges() {
    if (this.items.length > 0 && this.itemMax) {
      const productList = this.items.slice(0, this.itemMax);
      this.products = productList;
    } else {
      this.products = this.items;
    }
  }

  scrollToNext(el: HTMLElement) {
    const left = el.scrollLeft + el.offsetWidth;
    el.scrollTo({ left, behavior: 'smooth' });
    this.prevClickable = true;
    this.nextClickable = left < el.scrollWidth - el.offsetWidth;
    this.onScroll();
  }

  scrollToPrev(el: HTMLElement) {
    const left = el.scrollLeft - el.offsetWidth;
    el.scrollTo({ left, behavior: 'smooth' });
    this.nextClickable = el.scrollLeft > 0;
    this.prevClickable = left > 0;
    this.onScroll();
  }

  onProductClick(product: Product, position: number) {
    const event: ProductClick = { productId: product.id, position, title: this.trackingTitle };
    this.productClick.emit(event);
  }

  onScroll() {
    if (!this.isFirstScroll) {
      const event: TrackingModule = { title: this.trackingTitle };
      this.moduleScroll.emit(event);
      this.isFirstScroll = true;
    }
  }
}
